// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"afafe899","296":"7ae965ef","338":"1de6c90c","386":"f17e5655","430":"a6eae8bd","453":"d855a71b","456":"decef31d","790":"5472cd11"}[chunkId] + ".chunk.js";
};